import * as types from './constant'


export const setInitialSupportsAction = (version) => {
  return {
    type: types.SET_INITIAL_SUPPORTS,
    payload: version
  }
}
